/* Grey Chapel — gc-related.js
   Related products: title-then-tag overlap against the tag pool. See docs/related-products.md. */
(function () {
  'use strict';
  var GC = window.GC;
  if (!GC) return;

  /* ---------------- Related products ---------------- */

  /* #kqr3f Folds a word onto the stem Shopify's own tag search uses, so Whale and Whales
     match but Whals does not. Plurals only — Shopify gives tags no typo tolerance,
     so neither do we. Conservative: cross, glass, cactus and Ibis keep their tails. */
  function stemWord(w) {
    if (w.length < 4) return w;
    if (/(ss|us|is|as)$/.test(w)) return w;
    if (/ies$/.test(w)) return w.slice(0, -3) + 'y';
    if (/(ch|sh|x|z|s)es$/.test(w)) return w.slice(0, -2);
    if (/s$/.test(w)) return w.slice(0, -1);
    return w;
  }

  /* #by262 Held stemmed, so it is compared in the same shape as everything else — otherwise
     "does" arrives as "doe" and reads as a deer. "T-Shirt" is not here: it belongs
     to the Ignore tags setting, which a merchant can see and change. */
  var TITLE_STOP = {};
  (function () {
    var words = ('a an and the of or in on at to for from with without by my me i it its this that no not '
                 + 'is are was be am do does vol').split(' ');
    for (var i = 0; i < words.length; i++) TITLE_STOP[stemWord(words[i])] = true;
  }());

  function stopWord(w) {
    return TITLE_STOP[stemWord(String(w).toLowerCase())] === true;
  }

  /* The whole thing ("Bird Skulls" -> "bird skull") and the words it is built from:
     two tags can share a word without being the same tag. */
  function termSet(raw, splitOn) {
    var keys = {}, tokens = {}, size = 0;
    var list = String(raw || '').split(splitOn);
    for (var i = 0; i < list.length; i++) {
      var parts = list[i].toLowerCase().split(/[^a-z0-9]+/), key = [];
      for (var j = 0; j < parts.length; j++) {
        if (parts[j]) key.push(stemWord(parts[j]));
      }
      if (!key.length) continue;
      for (j = 0; j < key.length; j++) tokens[key[j]] = true;
      if (!keys[key.join(' ')]) { keys[key.join(' ')] = true; size++; }
    }
    return { keys: keys, tokens: tokens, size: size };
  }

  /* Cards arrive from two places — the pool carries its handle on a wrapper, the
     grid's own tiles carry it only in a link — so both are read the same way. */
  function cardHandle(card) {
    var a = card && card.querySelector ? card.querySelector('a[href*="/products/"]') : null;
    var m = a && /\/products\/([^/?#]+)/.exec(a.getAttribute('href') || '');
    return m ? m[1] : '';
  }

  /* #yc3l2 Strongest claim first — title words in reading order, then tags. A title word and
     a tag that reduce to the same thing are one group. Each is tried in turn. */
  function relatedTerms(src) {
    var ignore = {}, seen = {}, terms = [], i;

    var ig = String(src.ignore || '').split(',');
    for (i = 0; i < ig.length; i++) {
      var igk = termSet(ig[i], '|');
      for (var k in igk.keys) ignore[k] = true;
    }
    for (var s in TITLE_STOP) ignore[s] = true;

    function add(raw) {
      var one = termSet(raw, '|'), key = '';
      for (var kk in one.keys) { key = kk; break; }
      if (!key || ignore[key] || seen[key]) return;
      seen[key] = true;
      terms.push({ key: key, raw: raw, fromTitle: fromTitle });
    }

    var fromTitle = true;
    var words = String(src.title || '').split(/[^A-Za-z0-9]+/);
    for (i = 0; i < words.length; i++) {
      if (words[i].length > 1) add(words[i]);
    }

    fromTitle = false;
    var tags = String(src.tags || '').split('|');
    for (i = 0; i < tags.length; i++) add(tags[i]);

    return terms;
  }

  /* #k7f76 A title is a design's own account of what it is, so a word found there outranks
     the same word carried as a tag. 0 means no answer.
       1  whole term in the title      3  carried whole as a tag
       2  part of it is                4  part of it buried in one */
  function candSets(cand) {
    return {
      title: termSet(cand.getAttribute('data-gc-title'), /[^A-Za-z0-9]+/),
      tags: termSet(cand.getAttribute('data-gc-tags'), '|')
    };
  }

  function termTier(sets, term) {
    var words = term.key.split(' ');
    var allTitle = true, anyTitle = false, anyTag = false;
    for (var i = 0; i < words.length; i++) {
      if (sets.title.tokens[words[i]]) anyTitle = true; else allTitle = false;
      if (sets.tags.tokens[words[i]]) anyTag = true;
    }
    if (allTitle) return 1;
    if (anyTitle) return 2;
    if (sets.tags.keys[term.key]) return 3;
    if (anyTag) return 4;
    return 0;
  }

  var RELATED_SLOTS = 4;
  var RELATED_GROUPS = 8;
  var RELATED_CLAUSES = 20;

  /* #p5r1k Search answers are kept for the visit, so the cart's picks for the design just
     viewed reuse the requests the PDP's row already made (same section, same URL). One in flight is shared too. */
  var poolDone = {}, poolFlight = {};
  function poolText(url, signal) {
    if (poolDone[url] != null) return Promise.resolve(poolDone[url]);
    if (!poolFlight[url]) {
      poolFlight[url] = fetch(url, signal ? { signal: signal } : undefined)
        .then(function (r) { return r.text(); })
        .then(function (t) { poolDone[url] = t; delete poolFlight[url]; return t; },
              function (e) { delete poolFlight[url]; throw e; });
    }
    return poolFlight[url];
  }

  /* #s8w3h The finder, shared by the PDP row and the cart's picks. Resolves to the pool's
     .gc-tagcand nodes, best first, never more than opts.slots; [] when there is nothing to
     search on or every search failed. opts: title, tags ('|'-joined), ignore (','-joined),
     base (search URL), section, slots, exclude (handles), valid(node). */
  function find(opts) {
    var terms = relatedTerms(opts).slice(0, RELATED_GROUPS);
    var base = opts.base;
    if (!base || !terms.length) return Promise.resolve([]);

    /* #rhz8r Every term is asked of both fields, because a title behaves as a tag. Multi-word
       terms also ask per word, or "Black Cat" could only ever pool another Black Cat. */
    function queryFor(wantTitle) {
      var list = [], said = {}, i, p, parts;
      function clause(word) {
        var w = String(word).replace(/"/g, '').trim();
        if (!w || said[w.toLowerCase()] || list.length >= RELATED_CLAUSES) return;
        said[w.toLowerCase()] = true;
        list.push('title:"' + w + '" OR tag:"' + w + '"');
      }
      for (i = 0; i < terms.length; i++) {
        if (!!terms[i].fromTitle === wantTitle) clause(terms[i].raw);
      }
      for (i = 0; i < terms.length; i++) {
        if (!!terms[i].fromTitle !== wantTitle) continue;
        parts = String(terms[i].raw).split(/[^A-Za-z0-9]+/);
        if (parts.length < 2) continue;
        for (p = 0; p < parts.length; p++) {
          if (parts[p].length > 1 && !stopWord(parts[p])) clause(parts[p]);
        }
      }
      if (!list.length) return null;
      return base + '?q=' + encodeURIComponent(list.join(' OR '))
           + '&type=product&options[prefix]=none&options[unavailable_products]=hide'
           + '&section_id=' + opts.section;
    }

    /* Two requests, not one OR. Shark Teeth is tagged Animal, which answers 28 of 30
       places, so the three designs actually named "Teeth" never came back and the
       ranking ran over a candidate list that had already discarded the right answers.
       Splitting guarantees the title words their own hearing. */
    var urls = [];
    var titleUrl = queryFor(true), tagUrl = queryFor(false);
    if (titleUrl) urls.push(titleUrl);
    if (tagUrl) urls.push(tagUrl);
    if (!urls.length) return Promise.resolve([]);

    /* A search that never answers falls back like one that fails, rather than holding the caller. */
    var ctl = window.AbortController ? new AbortController() : null;
    if (ctl) setTimeout(function () { ctl.abort(); }, 8000);

    var exclude = {}, slots = opts.slots || RELATED_SLOTS, valid = opts.valid;
    (opts.exclude || []).forEach(function (h) { exclude[h] = true; });

    return Promise.all(urls.map(function (u) {
      return poolText(u, ctl && ctl.signal)
        .catch(function (e) { console.warn('gc-related: search failed, using the standing tiles', e); return ''; });
    })).then(function (docs) {
      var pool = [], seenCand = {}, i, d;
      for (d = 0; d < docs.length; d++) {
        var wrap = document.createElement('div');
        wrap.innerHTML = docs[d];
        var nodes = wrap.querySelectorAll('.gc-tagcand');
        for (i = 0; i < nodes.length; i++) {
          var hand = nodes[i].getAttribute('data-gc-handle');
          if ((valid && !valid(nodes[i])) || exclude[hand] || seenCand[hand]) continue;
          seenCand[hand] = true;
          pool.push(nodes[i]);
        }
      }

      /* Read each candidate once, then score the whole pool against every group. */
      var sets = [], g, k;
      for (i = 0; i < pool.length; i++) sets.push(candSets(pool[i]));

      var tiers = [], reach = [];
      for (g = 0; g < terms.length; g++) {
        tiers[g] = []; reach[g] = 0;
        for (i = 0; i < pool.length; i++) {
          tiers[g][i] = termTier(sets[i], terms[g]);
          if (tiers[g][i]) reach[g]++;
        }
      }

      /* Shopify returns tags alphabetically, never as typed, so "Animal" would open
         every group it appears in and spend all four slots on the broadest thing a
         design says about itself. Ordered by how much of the pool they answer
         instead — narrowest first. Title words keep their reading order. */
      var order = [], loose = [];
      for (g = 0; g < terms.length; g++) {
        if (terms[g].fromTitle) order.push(g);
        else if (reach[g]) loose.push(g);
      }
      loose.sort(function (a, b) { return (reach[a] - reach[b]) || (a - b); });
      order = order.concat(loose);

      /* Evidence leads, group order breaks ties, so a title match is never edged out
         by a buried tag in an earlier group. Equals are shuffled, so a design in a
         crowded group is not condemned to show the same four neighbours for ever. */
      var picks = [], taken = {};
      for (var tier = 1; tier <= 4 && picks.length < slots; tier++) {
        for (k = 0; k < order.length && picks.length < slots; k++) {
          g = order[k];
          var hits = [];
          for (i = 0; i < pool.length; i++) {
            if (!taken[i] && tiers[g][i] === tier) hits.push({ at: i, toss: Math.random() });
          }
          hits.sort(function (a, b) { return a.toss - b.toss; });
          for (i = 0; i < hits.length && picks.length < slots; i++) {
            taken[hits[i].at] = true;
            picks.push(pool[hits[i].at]);
          }
        }
      }
      return picks;
    });
  }

  GC.related = { find: find };

  GC.register('[data-related]', function (el) {
    /* #vbmn2 The server already rendered this grid and CSS shows it as a skeleton while JS
       runs. With no JS the shopper keeps what Liquid gave them, untouched. */
    var host = el.querySelector('.gc-related--nojs') || el.querySelector('.gc-section');
    var grid = el.querySelector('.gc-grid');
    if (!host || !grid) return;

    /* Tells the section's load failsafe this module is alive and will end the skeleton. */
    el.setAttribute('data-related-live', '');

    /* Seven designs share no tag or title word with anything else, so best-selling
       fallbacks stay in hand to top the row back up to four. */
    var standing = Array.prototype.slice.call(grid.children);

    function reveal(cards) {
      var seen = {}, keep = [], i, h;
      for (i = 0; i < cards.length && keep.length < RELATED_SLOTS; i++) {
        h = cardHandle(cards[i]);
        if (h && seen[h]) continue;
        if (h) seen[h] = true;
        keep.push(cards[i]);
      }
      grid.innerHTML = '';
      for (i = 0; i < keep.length; i++) grid.appendChild(keep[i]);
      host.classList.remove('gc-related--nojs');
      /* These tiles missed DOMContentLoaded, so nothing has handed their real
         candidates over yet. Without this they stay on the placeholder. */
      GC.progressive.init(el);
      /* Nor has anything fitted their titles (card titles, gc-ui.js). */
      GC.boot(grid);
      /* And they missed the warm pass on load, so they would be the one grid still
         loading a row at a time under the shopper. */
      if (GC.warmTiles) GC.warmTiles();
    }

    find({
      title: el.getAttribute('data-gc-title'), tags: el.getAttribute('data-gc-tags'),
      ignore: el.getAttribute('data-gc-ignore'), base: el.getAttribute('data-url'),
      section: 'related-tag-pool', slots: RELATED_SLOTS, exclude: [el.getAttribute('data-gc-handle')],
      valid: function (n) { return !!n.firstElementChild; }
    }).then(function (nodes) {
      reveal(nodes.map(function (n) { return n.firstElementChild; }).concat(standing));
    }).catch(function () { reveal(standing); });
  });

  /* The cart loads this module on demand on pages that do not ship it; this says it is in. */
  GC.emit('related:ready', GC.related);
})();
